// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { request } from "@insite/client-framework/Services/ApiService";
import translate from "@insite/client-framework/Translate";
import { BaseAddressModel } from "@insite/client-framework/Types/ApiModels";

const uri = "/api/vmi/addresses/ShipToAddress";

export interface MyAccountAddressApiParameter {
    addressModel?: BaseAddressModel;
    file?: any;
}

export const submitVmShipToAddress = async (parameters: MyAccountAddressApiParameter) => {
    try {
        const { file, addressModel } = parameters;
        const formData = new FormData();
        if (file) formData.append("file", file);
        formData.append("addressModel", JSON.stringify(addressModel));
        await request<(MyAccountAddressApiParameter | null)[]>(uri, "POST", {}, formData);
        return {
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error?.errorJson?.message ?? translate("An error occured during address submission."),
        };
    }
};
